import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../common/http/http-utils';

@Injectable()
export class DashboardServiceVcd {

    private computeSummary: any;
    private networkSummary: any;

    constructor(public http: HttpClient) {
    }

    getComputeSummary() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vcd/compute/summary')
            .map(res => this.computeSummary = res);
    }

    getAllNetworks() {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/networks')
            .map(res => res);
    }

    getAllGateways() {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/gateways')
            .map(res => res);
    }

    getIpUsage(networkId: string) {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/networks/' + networkId + '/ipCount')
            .map(res => res);
    }

    getVcs() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
            .map(res => res);
    }

    getVMsForVC() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vm')
            .map(res => res);
    }

    getDirectConnectList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vcd/networks/inventory/query?entityType=directConnect')
            .map(
                res => res
            );
    }

    getVDCNetworkList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vdcNetworks')
            .map(
                res => res
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.service.ts